import React from 'react';

const DWRCoating = ({ ...props }) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M21.7261 24.6314C16.8746 24.6931 12.8746 20.8987 12.7954 16.4072H28.835L31 4H5.13861L4.16832 9.76864C5.72607 8.3126 7.87789 7.39949 10.2673 7.36864C15.1188 7.30694 19.1188 10.9039 19.198 15.4015H3.16502L1 28H26.8548L27.8251 22.2314C26.2673 23.6874 24.1155 24.6005 21.7261 24.6314Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default DWRCoating;
